

<div *ngIf="config && config.hasToggle">
    <h3 *ngIf="config" class="mt-6 mb-3 toggel-header" (click)="HeaderToggel(config)">{{config.label}}
        <ng-container *ngIf="ShowingToggelContent; else chevronRight">
            <ng-container *ngTemplateOutlet="arrowDown"></ng-container>
          </ng-container>       
    </h3>    
  </div>

  
<div *ngIf="config && !config.hasToggle">
    <h3 *ngIf="config" class="mt-6 mb-3" >{{ config.label}}  </h3>
  </div>



<ng-template #chevronRight>
  <svg class="icon-svg">
    <use xlink:href="#chevron-right"></use>
  </svg>
</ng-template>
<ng-template #arrowDown>
  <svg class="icon-svg">
    <use xlink:href="#angle-arrow-down"></use>
  </svg>
</ng-template>